export enum DateSelectModeEnum {
  Fixed = 1,
  Rolling = 2,
}
